import { createSelector } from "reselect";
import { getPageContent } from "shared/selectors/base";
import { get } from "lodash";

// eslint-disable-next-line import/prefer-default-export
export const getRoomTypes = createSelector([getPageContent], pageContent =>
  get(pageContent, ["room_types"], [])
);
